import actionTypes from 'SRC/modules/redux/actionTypes'

export const setOrderForm = orderForm => ({
  type: actionTypes.SET_VEHICLE_PARTS_ORDER_FORM,
  payload: orderForm
})
